<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <!-- <legend>PARTICIPACIÓN EN EMPRESAS, SOCIEDADES O ASOCIACIONES (HASTA LOS ULTIMOS 2 AÑOS)<br> </legend> -->
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">PARTICIPACIÓN EN EMPRESAS, SOCIEDADES O ASOCIACIONES (HASTA LOS ULTIMOS 2 AÑOS) </legend>
        </div>

      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿Tiene participación en empresas, sociedades o asociaciones ? <b-button class="btn-popover" v-b-popover.hover.top="info.participacion"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de la pareja o dependientes económicos no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Datos del participante</legend>
          <div class="col-md-12 form-group">
            <label class="control-label">Señalar quien participa <b-button class="btn-popover" v-b-popover.hover.top="info.participante"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="1" class="d-inline-block">Declarante</p-radio>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="2" class="d-inline-block">Pareja</p-radio>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="3" class="d-inline-block">Dependiente Económico</p-radio>
            <br><small class="text-danger">{{ errors.first('participante')}}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label">Nombre de la empresa, sociedad o asociación <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre_empresa_sociedad_asociacion" placeholder="Nombre de la Empresa, Sociedad o Asociación">
            <small class="text-danger">{{ errors.first('nombre')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Porcentaje de participación de acuerdo a escritura <b-button class="btn-popover" v-b-popover.hover.top="info.porcentaje"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="porcentaje" v-validate="'required|between:1,100'" v-model="form_item.porcentaje_participacion" controls-position="right" :step="5" :min="0" :max="100"></el-input-number>

            <!-- <input class="form-control" type="text" name="porcentaje" v-validate="'required'" v-model="form_item.porcentaje" placeholder="Porcentaje de participación"> -->
            <small class="text-danger">{{ errors.first('porcentaje')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de Participación <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_participacion"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="tipo_participacion" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.naturaleza_vinculo">
              <el-option v-for="option in tipos_participaciones" class="select-default" :value="option.id" :label="option.valor" :key="option.valor"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_participacion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.naturaleza_vinculo == 8">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique" v-validate="'required'" v-model="form_item.naturaleza_vinculo_especificar" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique')}}</small>
          </div>
          <div class="col-6 form-group">
            <label class="control-label">¿Recibe remuneración por su participación? <b-button class="btn-popover" v-b-popover.hover.top="info.remuneracion"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="remuneracion" v-validate="'required'" v-model="form_item.remuneracion" label="1" class="d-inline-block">SI</p-radio>
            <p-radio name="remuneracion" v-validate="'required'" v-model="form_item.remuneracion" label="2" class="d-inline-block">NO</p-radio>
            <small class="text-danger">{{ errors.first('remuneracion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.remuneracion == '1'">
            <label class="control-label">Monto mensual neto <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0"></el-input-number>
            <!-- <input class="form-control" type="text" name="monto" v-validate="'required'" v-model="form_item.monto" placeholder="Monto mensual aproximado">
             --><small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <div class="col-6">
            <label class="control-label">Sector productivo al que pertenece <b-button class="btn-popover" v-b-popover.hover.top="info.sector"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable class="select-default" placeholder="Sector" filterable name="sector" v-model="form_item.sector_industria_id" v-validate="'required'">
              <el-option v-for="option in sectores_industria" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">
              {{ errors.first('sector') }}
            </small>
          </div>
          <legend>Lugar donde se ubica <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group  col-6">
            <label class="control-label"> País </label>
            <el-select clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.domicilio_pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.domicilio_pais_id==150">
            <label class="control-label"> Entidad Federativa </label>
            <el-select clearable class="select-default" name="entidad" v-validate="'required'" filterable placeholder="Entidad" v-model="form_item.domicilio_entidad_federativa_id">
              <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('entidad') }}</small>
          </div>
          <div class="form-group col-md-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.participante="{ item }">
                <div>{{filterDeclarante(item.participante)}}</div>
              </template>
              <template v-slot:item.naturaleza_vinculo="{ item }">
                <div>{{filterTipoParticipacion(item.naturaleza_vinculo)}}</div>
              </template>
              <template v-slot:item.remuneracion="{ item }">
                <div>{{filterBool(item.remuneracion)}}</div>
              </template>
              <template v-slot:item.sector_industria_id="{ item }">
                <div>{{filterSector(item.sector_industria_id)}}</div>
              </template>
              <template v-slot:item.monto="{ item }">
                <div>${{item.monto | currency}}</div>
              </template>
              <template v-slot:item.porcentaje_participacion="{ item }">
                <div>{{item.porcentaje_participacion}} %</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
    },
    props: ["data"],
    data() {
      return {
        ip_id: 1,
        /* bienes2: null,
        tipo_participacion: null,
        bienes: null, */
        add_item: false,
        edit_item: null,
        bandera: '0',
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Participación en empresas',
          value: 'participante',
          align: 'center',
        }, {
          text: 'Nombre de la empresa',
          value: 'nombre_empresa_sociedad_asociacion',
          align: 'center',
        }, {
          text: 'RFC de la empresa',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Tipo de participación',
          value: 'naturaleza_vinculo',
          align: 'center',
        }, {
          text: 'Porcentaje de participación',
          value: 'porcentaje_participacion',
          align: 'center',
        }, {
          text: '¿Recibe remuneración por su participación?',
          value: 'remuneracion',
          align: 'center',
        }, {
          text: 'Monto mensual neto',
          value: 'monto',
          align: 'center',
        }, {
          text: 'Sector',
          value: 'sector_industria_id',
          align: 'center',
        }, ],
        info: {
          participacion: 'El Declarante deberá señalar si tiene o no participación en empresas, sociedades o asociaciones, tales como socio, accionista, comisario, representante, apoderado, colaborador, beneficiario u otro, especifique. Deberá reportar hasta los últimos dos años.',
          participante: 'Señalar quien tiene participación en la empresa sociedad o asociación.',
          nombre: 'Señalar el nombre o razón social completo de la empresa, sociedad o asociación, tal y como aparece en el documento legal en el que participe.',
          rfc: 'Proporcionar los 12 dígitos del registro de la empresa, sociedad o asociación en la cual participa.',
          porcentaje: 'Indicar el porcentaje de participación en la empresa, sociedad o asociación.',
          tipo_participacion: 'Seleccionar de la lista desplegable una de las siguientes opciones: socio, accionista, comisario, representante, apoderado, colaborador, beneficiario u otro, especifique.',
          remuneracion: 'Señalar sí o no.',
          monto: 'Especificar el monto mensual neto, sin centavos, que percibe por su participación.',
          sector: 'Elegir el sector al que pertenece la empresa, sociedad o asociación. En caso de señalar otro, especifique.',
          lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa o en el extranjero, debiendo señalar el país donde se localiza.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    watch: {},
    methods: {
      showItem() {
        this.add_item = true;
        this.$validator.resume();
        if (!this.form_item.domicilio_pais_id) {
          //El id Mexico es 150
          this.form_item.domicilio_pais_id = 150;
        }
      },
      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("empresasasc", this.form_item).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.$el.querySelector("[aria-invalid=true]").scrollIntoView({
              block: "center",
              behavior: "smooth"
            });
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("empresasasc/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
    },
    created() {
      this.ip_id = this.getKey('uid');
      //this.getLocalidades(97250);
      this.$http.get("empresasasc").then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
    },
    mounted() {
      this.checkCatalogs();
      //El id Mexico es 150
      this.form_item.domicilio_pais_id = 150;
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/EmpresasSoc.vue